/* eslint-disable import/prefer-default-export */
/* eslint-disable lodash/prefer-lodash-method */

import { isEmpty } from 'lodash';

export function validateHashtags(input) {
  const cleaned = input.replace(/,+$/, '');
  const tags = cleaned.replace(/,+$/, '').split(',').map(t => t.trim());

  const validationRegex = /^([#|@|$])?[\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFFA-zÀ-úа-яА-Я.0-9]{2,}$/;

  const invalid = tags.filter(tag => {
    // Reject empty, all dots, all commas, all spaces
    if (!tag || /^[.,\s]+$/.test(tag)) return true;
    return !validationRegex.test(tag);
  });

  if (invalid.length > 0) {
    return { valid: false, invalidTags: invalid.filter(element => !isEmpty(element)) };
  }
  return { valid: true, tags };
}



/** WEBPACK FOOTER **
 ** ./src/components/hashtags-input/utils.js
 **/